module.exports = __webpack_public_path__ + "static/img/F3-.34dd8be1.png";